// 项目主管角色首页
const ProjAdmin = () => import(/* webpackChunkName: "index" */ './ProjAdmin');
// 成果主管角色首面
const AchiAdmin = () => import(/* webpackChunkName: "index" */ './AchiAdmin');
// 院科研秘书
const Secretary = () => import(/* webpackChunkName: "index" */ './Secretary');


export default {
    routes: [
        {
            path: '/entries/proj/admin',
            name: 'entries_proj_admin',
            component: ProjAdmin
        },
        {
            path: '/entries/achi/admin',
            name: 'entries_achi_admin',
            component: AchiAdmin
        },
        {
            path: '/entries/secretary',
            name: 'entries_secretary',
            component: Secretary
        }
    ]
}
